import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import "../../../Assets/css/cbMetal.css";
import GoldImg from "../../../Assets/images/cultured-img/metals/gold.jpg";
import silver from "../../../Assets/images/cultured-img/metals/silver.jpg";
import tungsten from "../../../Assets/images/cultured-img/metals/tungsten.jpg";
import cobalt from "../../../Assets/images/cultured-img/metals/cobalt.jpg";
import platinum from "../../../Assets/images/cultured-img/metals/platinum.jpg";
import palladium from "../../../Assets/images/cultured-img/metals/palladium.jpg";
import { useHistory } from "react-router-dom";

const CdMetals = () => {
  const history = useHistory();
  return (
    <>
      <div className="cb_metal_section">
        <div className="cb_metal_banner">
            <Container fluid>
            <div className="cd_metal_banner_text">
            <h1>A Guide for Jewelry Metals</h1>
            <p>
              As you shop Cultured Brilliance, you will notice that our standard
              metal choices include Platinum and 14K Gold in White, Yellow and
              Rose. If you would like another metal choice, please contact your
              CB Concierge for availability and pricing.
            </p>
            <buton className="rcs_acc_button " type='button' onClick={() => history.push('/contact')}>Contact CB Concierge</buton>
          </div>
            </Container>
          
        </div>
        <Container fluid>
          <Row>
            <Col sm={12} md={12} lg={12} className="p-0">
              <div className="cb_metal_main_sub_heading">
                <ul>
                  <li>
                    <a href="#gold">Gold</a>
                  </li>
                  <li>
                    <a href="#silver">Silver</a>
                  </li>
                  <li>
                    <a href="#tungsten">Tungsten</a>
                  </li>
                  <li>
                    <a href="#cobalt">Cobalt</a>
                  </li>
                  <li>
                    <a href="#platinum">Platinum </a>
                  </li>
                  <li>
                    <a href="#palladium">Palladium</a>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
          <Row id="gold">
            <Col
              sm={12}
              md={6}
              lg={6}
              className="p-0 d-flex justify-content-center align-items-center order_1"
            >
              <div className="cb_metal_text_box">
                <h2>Gold</h2>
                <p>
                  Gold is an enduring element found naturally in a distinct
                  yellow color. Gold has an extraordinary heritage with unique
                  qualities. Gold is resistant to rust, tarnish, and corrosion.
                  Although gold is very strong, it’s also the most malleable of
                  all precious metals. Pure gold is too soft for everyday wear,
                  so it is alloyed with a mixture of metals like silver, copper,
                  nickel, and zinc to give it strength and durability.
                </p>
                <p>
                  Gold also comes in White – a gold alloy made with nickel,
                  platinum or another metal, and Rose – a gold alloy made with
                  copper. Karat is a unit of purity, with 24K being 100% pure
                  and 14K is 58.3% of gold purity. We typically recommend 14K
                  for jewelry because of its durability and appearance.
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={6} className="p-0 order_2">
              <div className="cb_metal_img_box">
                <Image src={GoldImg} alt="Gold Image" className="img-fluid" />
              </div>
            </Col>
          </Row>
          <Row id="silver">
            <Col sm={12} md={6} lg={6} className="p-0">
              <div className="cb_metal_img_box">
                <Image src={silver} alt="Gold Image" className="img-fluid" />
              </div>
            </Col>
            <Col
              sm={12}
              md={6}
              lg={6}
              className="p-0 d-flex justify-content-center align-items-center"
            >
              <div className="cb_metal_text_box">
                <h2>Silver</h2>
                <p>
                  Silver is relatively soft, very malleable. Pure silver, also
                  called fine silver, is commonly combined with other metals to
                  produce a more durable product. The most popular of these
                  alloys is sterling silver, which consists of 92.5 percent
                  silver and 7.5 percent copper. Although any metal can make up
                  the 7.5 percent non-silver portion of sterling, centuries of
                  experimentation have shown copper to be its best companion,
                  improving the metal’s hardness and durability without
                  affecting its beautiful color.
                </p>
              </div>
            </Col>
          </Row>
          <Row id="tungsten">
            <Col
              sm={12}
              md={6}
              lg={6}
              className="p-0 d-flex justify-content-center align-items-center order_1"
            >
              <div className="cb_metal_text_box">
                <h2>Tungsten</h2>
                <p>
                Tungsten is tarnish-resistant with a substantial feel in weight. Tungsten is nearly impossible to scratch or wear down, so even the most delicate details are well-defined and polished after years of wear. Four times harder than titanium, tungsten retains its polish longer than almost any other metal. A practical and beautiful choice for gardeners, or anyone who works actively using their hands.
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={6} className="p-0 order_2">
              <div className="cb_metal_img_box">
                <Image src={tungsten} alt="Gold Image" className="img-fluid" />
              </div>
            </Col>
          </Row>
          <Row id="cobalt">
            <Col sm={12} md={6} lg={6} className="p-0">
              <div className="cb_metal_img_box">
                <Image src={cobalt} alt="Gold Image" className="img-fluid" />
              </div>
            </Col>
            <Col
              sm={12}
              md={6}
              lg={6}
              className="p-0 d-flex justify-content-center align-items-center"
            >
              <div className="cb_metal_text_box">
                <h2>Cobalt</h2>
                <p>
                Cobalt is a bright white metal that is highly scratch resistant. Made from a highly durable alloy, cobalt is four times harder than platinum while at the same time, less dense. Because of its natural hardness, cobalt jewelry is extremely scratch, chip and corrosion-resistant. Its lower density and natural malleability allow for strong, dynamic designs with less weight. Cobalt is also hypoallergenic, making it an ideal choice for those with sensitive skin or an active lifestyle.
                </p>
              </div>
            </Col>
          </Row>
          <Row id="platinum">
            <Col
              sm={12}
              md={6}
              lg={6}
              className="p-0 d-flex justify-content-center align-items-center order_1"
            >
              <div className="cb_metal_text_box">
                <h2>Platinum</h2>
                <p>
                Platinum will last forever, making it the ultimate symbol for true, enduring, and everlasting love. Platinum is durable. Its density makes it the most secure setting for your diamond or precious gemstone. Because platinum is a naturally white metal, re-plating is unnecessary; it will always hold its beauty.
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={6} className="p-0 order_2">
              <div className="cb_metal_img_box">
                <Image src={platinum} alt="Gold Image" className="img-fluid" />
              </div>
            </Col>
          </Row>
          <Row id="palladium">
            <Col sm={12} md={6} lg={6} className="p-0">
              <div className="cb_metal_img_box">
                <Image src={palladium} alt="Gold Image" className="img-fluid" />
              </div>
            </Col>
            <Col
              sm={12}
              md={6}
              lg={6}
              className="p-0 d-flex justify-content-center align-items-center"
            >
              <div className="cb_metal_text_box">
                <h2>Palladium</h2>
                <p>
                Palladium is a rare precious metal, treasured for its brilliant silver-white surface that can be polished to a high mirror-like shine. Palladium wedding rings are extremely durable and resistant to tarnishing, extreme heat, and exposure to many types of chemicals. The strength of palladium makes it a preferred metal, along with platinum, for use in ring settings.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CdMetals;
